/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Freefeature11Inputs */

const zh_plan_freefeature11 = /** @type {(inputs: Plan_Freefeature11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日 3 次 AI 对话`)
};

const en_plan_freefeature11 = /** @type {(inputs: Plan_Freefeature11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 AI conversations per day`)
};

const es_plan_freefeature11 = /** @type {(inputs: Plan_Freefeature11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 conversaciones IA por día`)
};

/**
* | output |
* | --- |
* | "3 AI conversations per day" |
*
* @param {Plan_Freefeature11Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_freefeature11 = /** @type {((inputs?: Plan_Freefeature11Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Freefeature11Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_freefeature11(inputs)
	if (locale === "en") return en_plan_freefeature11(inputs)
	return es_plan_freefeature11(inputs)
});
export { plan_freefeature11 as "plan_freeFeature1" }